'use strict';

require('./flatten-a717674f.js');
require('./variadic.js');
require('./isArray-fff5bad6.js');
require('./head.js');
require('./tail.js');
require('./copy.js');
var _get = require('./_get.js');
require('./_rollupPluginBabelHelpers-ad34ecfb.js');
var _set = require('./_set.js');

function pick(ks, o) {
  return ks.reduce(function (p, k) {
    return _set(k, _get(k, o), p);
  }, {});
}

module.exports = pick;
